import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { SaldeoService } from '../../@core/http/saldeo.service';

@Component({
  selector: 'ngx-saldeo',
  templateUrl: './saldeo.component.html',
})
export class SaldeoComponent implements OnInit {

  constructor(
    private readonly router: Router,
    private readonly saldeoService: SaldeoService,
    private readonly toastrService: NbToastrService,
    private readonly translate: TranslateService,
  ) { }

  ngOnInit() {
    this.saldeoService.getUrlLogowanie().subscribe(response => {
      if (response.url) {
        window.location.replace(response.url);
      } else {
        this.router.navigate(['']);
        this.toastrService.show(this.translate.instant('komunikat.blad.saldeo-logowanie'), 'Saldeo', { status: 'danger' });
      }
    });
  }
}
